import debounce from 'lodash/debounce';
import { toggleAttribute, getWindowSize, findOffset, slideToggle } from '../helper';

let actLevelMobileMenu = 0;
let actView;
let actWindowWidth;

const BP_TABLET = 991;
const BP_DESKTOP = 992;

const STATE_CLOSED = 'closed';
const STATE_OPEN = 'open';
const STATE_TRUE = 'true';
const STATE_FALSE = 'false';
const STATE_HAS_CHILDREN = 'has-children';

const CLASSNAME__ANIMATION = 'animate';
const CLASSNAME__ANIMATION_SLIDE_IN_LEFT = `${CLASSNAME__ANIMATION}--menu-slide-in-left`;
const CLASSNAME__ANIMATION_SLIDE_IN_RIGHT = `${CLASSNAME__ANIMATION}--menu-slide-in-right`;
const CLASSNAME__ANIMATION_SLIDE_OUT_LEFT = `${CLASSNAME__ANIMATION}--menu-slide-out-left`;
const CLASSNAME__ANIMATION_SLIDE_OUT_RIGHT = `${CLASSNAME__ANIMATION}--menu-slide-out-right`;

const ANIMATION_CLASSNAMES = [
  CLASSNAME__ANIMATION_SLIDE_IN_LEFT,
  CLASSNAME__ANIMATION_SLIDE_IN_RIGHT,
  CLASSNAME__ANIMATION_SLIDE_OUT_LEFT,
  CLASSNAME__ANIMATION_SLIDE_OUT_RIGHT,
];

const CLASSNAME__HEADER__BOTTOM = 'header__bottom';
const CLASSNAME__MENU = 'vd-menu';
const CLASSNAME__MENU_ITEM = `${CLASSNAME__MENU}__item`;

const CLASSNAME__MENU_BUTTON = `${CLASSNAME__MENU}__button`;
const CLASSNAME__MENU_BUTTON__BACK = `${CLASSNAME__MENU_BUTTON}--back`;
const CLASSNAME__MENU_BUTTON__NEXT = `${CLASSNAME__MENU_BUTTON}--next`;
const CLASSNAME__MENU_BUTTON__TOP = `${CLASSNAME__MENU_BUTTON}--top`;

const CLASSNANME__MENU_DROPDOWN = `${CLASSNAME__MENU}__dropdown`;

const CLASSNAME__SUBMENU = 'vd-submenu';

const SELECTOR__HEADER = '.vd-section--header';
const SELECTOR__HEADER__BOTTOM = `.${CLASSNAME__HEADER__BOTTOM}.mobile`;
const SELECTOR__NAV_TOGGLE = '.nav-toggle';

const SELECTOR__NAVIGATION = '#navigation-main';

const SELECTOR__MENU_MEGA = '#menu-mega';
const SELECTOR__MENU = `.${CLASSNAME__MENU}`;
const SELECTOR__MENU_BUTTON = `.${CLASSNAME__MENU_BUTTON}`;
const SELECTOR__MENU_BUTTON__BACK = `.${CLASSNAME__MENU_BUTTON__BACK}`;
const SELECTOR__MENU_BUTTON__NEXT = `.${CLASSNAME__MENU_BUTTON__NEXT}`;
const SELECTOR__MENU_BUTTON__TOP = `.${CLASSNAME__MENU_BUTTON__TOP}`;
const SELECTOR__MENU_ITEM = `.${CLASSNAME__MENU_ITEM}`;
const SELECTOR__MENU_ITEM_PREV = `${SELECTOR__MENU_ITEM}.back-to-parent>${SELECTOR__MENU_BUTTON__BACK}`;
const SELECTOR__MENU_ITEM_NEXT = `${SELECTOR__MENU_ITEM}.${STATE_HAS_CHILDREN}>${SELECTOR__MENU_BUTTON__NEXT}`;
const SELECTOR__MENU_DROPDOWN = `.${CLASSNANME__MENU_DROPDOWN}`;
const SELECTOR__SUBMENU = `.${CLASSNAME__SUBMENU}`;

const VIEW__MOBILE = 'mobile';
const VIEW__DESKTOP = 'desktop';

const isMobile = () => {
  return actWindowWidth < BP_DESKTOP;
};

const init__onReady = () => {
  openMobileMenu();
  closeMobileMenu(true);

  openNextMenuLayer();
  openPrevMenuLayer();
};

const init = () => {
  const CHECK_WINDOW_WIDTH = getWindowSize().width;
  if (typeof actWindowWidth === 'undefined') {
    actWindowWidth = CHECK_WINDOW_WIDTH;
  }
  const CHECK_VIEW = CHECK_WINDOW_WIDTH < BP_DESKTOP ? VIEW__MOBILE : VIEW__DESKTOP;
  if (typeof actView === 'undefined') {
    actView = CHECK_VIEW;
  }

  if (CHECK_WINDOW_WIDTH === actWindowWidth || actView === CHECK_VIEW) {
    return;
  }

  if (actView === VIEW__MOBILE && CHECK_VIEW === VIEW__DESKTOP) {
    resetMobileMenu();
  }
  if (actView === VIEW__DESKTOP && CHECK_VIEW === VIEW__MOBILE) {
    resetDesktopMenu();
  }

  actView = CHECK_VIEW;
  actWindowWidth = CHECK_WINDOW_WIDTH;
  console.log(actWindowWidth);
};

const resetDesktopMenu = () => {
  console.log('--- reset desktop menu ---');
  $(SELECTOR__MENU_DROPDOWN).removeClass('show');
  $(SELECTOR__MENU_BUTTON).removeClass('active');

  //$(SELECTOR__MENU).removeClass('active-menu');
  $(SELECTOR__SUBMENU).removeClass('active-menu');
  $(`${SELECTOR__SUBMENU}[data-level="1"]`).attr('style', '');
  $(`${SELECTOR__MENU_ITEM}.back-to-parent`).attr('style', '');
  actLevelMobileMenu = 0;
};

const resetMobileMenu = () => {
  console.log('--- reset mobile menu ---');
  $(SELECTOR__MENU_DROPDOWN).removeClass('show');
  $(SELECTOR__MENU_BUTTON).show();
  $(SELECTOR__MENU_ITEM).show();
  $(`${SELECTOR__MENU_ITEM}.back-to-parent`).hide();
  $(`[data-level="1"] ${SELECTOR__SUBMENU} ${SELECTOR__MENU_ITEM}.back-to-parent`).show();
  $(SELECTOR__SUBMENU).show();
  $(`[data-level="1"] ${SELECTOR__SUBMENU}`).hide();
  ANIMATION_CLASSNAMES.forEach((item) => {
    $('.animate').removeClass(item).removeClass('animate');
  });
  closeMobileMenu(false, $(SELECTOR__MENU_MEGA), $(SELECTOR__NAV_TOGGLE));

  actLevelMobileMenu = 0;
};

const openMobileMenu = () => {
  console.log('openMobileMenu');
  $(document).on(
    'click',
    `${SELECTOR__HEADER__BOTTOM} ${SELECTOR__NAV_TOGGLE}[aria-expanded="false"]`,
    function () {
      const target = $(this).data('target');
      console.log($(this));
      $(target)
        .find('#navigation-main')
        .addClass(STATE_OPEN)
        .removeClass(STATE_CLOSED)
        .parents('.header__bottom')
        .addClass(STATE_OPEN)
        .removeClass(STATE_CLOSED);
      $(this).attr('aria-label', 'Menü schließen');
      $(this).attr('aria-expanded', STATE_TRUE);
      $('html').addClass('mega-menu-opened');
    }
  );
};

const closeMobileMenu = (onClick, target, _caller) => {
  if (!onClick) {
    if (!target) {
      return;
    }
    closeMenu(_caller, target);
    return;
  }

  function closeMenu(_caller, target) {
    console.log(target);
    target
      .find('#navigation-main')
      .addClass(STATE_CLOSED)
      .removeClass(STATE_OPEN)
      .parents('.header__bottom')
      .addClass(STATE_CLOSED)
      .removeClass(STATE_OPEN);
    _caller.attr('aria-label', 'Menü öffnen');
    _caller.attr('aria-expanded', STATE_FALSE);
    $('html').removeClass('mega-menu-opened');
  }

  $(document).on(
    'click',
    `${SELECTOR__HEADER__BOTTOM} ${SELECTOR__NAV_TOGGLE}[aria-expanded="true"]`,
    function () {
      const _caller = $(this);
      const target = $(_caller.data('target'));
      closeMenu(_caller, target);
    }
  );
};

const openNextMenuLayer = () => {
  console.log('--- openNextMenuLayer (mobile) ---');
  $(document).on('click', `${SELECTOR__HEADER__BOTTOM} ${SELECTOR__MENU_ITEM_NEXT}`, function () {
    if (!isMobile()) {
      return;
    }
    console.log(actLevelMobileMenu);
    const NEXT_LEVEL = actLevelMobileMenu + 1;
    const SELECTOR__NEXT_MENU_LAYER = `${SELECTOR__SUBMENU}[data-level="${NEXT_LEVEL}"]`;

    const NEXT_MENU_LAYER_ID = $(this).attr('data-target');
    const NEXT_MENU_LAYER = $(`${NEXT_MENU_LAYER_ID}`);

    setTimeout(() => {
      setTimeout(() => {
        const ACTIVE_BUTTONS = NEXT_MENU_LAYER.find(` > ${SELECTOR__MENU_ITEM}`).find(
          `> ${SELECTOR__MENU_BUTTON}`
        );
        NEXT_MENU_LAYER.addClass('active-menu');
        ACTIVE_BUTTONS.show();
        animateSliderWrapper($(this), CLASSNAME__ANIMATION_SLIDE_IN_LEFT);
      }, 150);
      $(SELECTOR__MENU_BUTTON).hide();
    }, 300);
    animateSliderWrapper($(this), CLASSNAME__ANIMATION_SLIDE_OUT_RIGHT);
    actLevelMobileMenu = NEXT_LEVEL;
  });
};

const openPrevMenuLayer = () => {
  console.log('--- openPrevMenuLayer (mobile) ---');
  $(document).on('click', `${SELECTOR__HEADER__BOTTOM} ${SELECTOR__MENU_ITEM_PREV}`, function () {
    if (!isMobile()) {
      return;
    }
    const PREV_MENU_LEVEL = actLevelMobileMenu - 1;
    const THIS_MENU_LAYER = $(this).parents`[data-level="${actLevelMobileMenu}"]`;
    const PREV_MENU_LAYER = $(this).parents(`[data-level="${PREV_MENU_LEVEL}"]`);

    setTimeout(() => {
      setTimeout(() => {
        const ACTIVE_BUTTONS = PREV_MENU_LAYER.find(` > ${SELECTOR__MENU_ITEM}`).find(
          `> ${SELECTOR__MENU_BUTTON}`
        );
        ACTIVE_BUTTONS.show();
        THIS_MENU_LAYER.removeClass('active-menu');
        PREV_MENU_LAYER.addClass('active-menu');
        animateSliderWrapper($(this), CLASSNAME__ANIMATION_SLIDE_IN_RIGHT);
      }, 150);
      $(SELECTOR__MENU_BUTTON).hide();
    }, 300);
    animateSliderWrapper($(this), CLASSNAME__ANIMATION_SLIDE_OUT_LEFT);
    actLevelMobileMenu = PREV_MENU_LEVEL;
  });
};

const animateSliderWrapper = (el, animationName) => {
  const sliderWrapper = el.parents('.slider-wrapper-mobile');
  ANIMATION_CLASSNAMES.forEach((item) => {
    sliderWrapper.removeClass(item);
  });
  sliderWrapper.addClass(`animate ${animationName}`);
};

window.addEventListener(
  'resize',
  debounce(() => init(), 200)
);

const domReady = (cb) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb);
};

domReady(() => {
  setTimeout(() => {
    init__onReady();
  }, 250);
  init();
});
